import React from 'react';
import StatusIcon from './StatusIcon';
import { StatusKeys } from './types';
import useStyles from './styles';

type Props = {
  title: string;
  statusKey: StatusKeys;
};

const StatusSelectOption = ({ statusKey, title }: Props) => {
  const classes = useStyles();
  return (
    <div className={classes.option}>
      <StatusIcon statusKey={statusKey} />
      <span className={classes.title}>
        {title}
      </span>
    </div>
  );
};

export default StatusSelectOption;
